/**
 * 时间转为 2017-01-01 00：00：00
 *
 * @export
 * @param {any} inputTime  时间戳
 * @returns
 */
export function formatDateTime(inputTime, showTime = true) {
  if(!inputTime && inputTime!==0){
    return ''
  }
  const date = new Date(inputTime);
  const y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let minute = date.getMinutes();
  minute = minute < 10 ? ('0' + minute) : minute;
  let second = date.getSeconds()
  second = second < 10 ? ('0' + second) : second;
  return showTime ? y + '-' + m + '-' + d + ' ' + h + ':' + minute+':'+second : y + '-' + m + '-' + d;
}


export function formatDateTimeExceptSecond(inputTime) {
  if(!inputTime && inputTime!==0){
    return ''
  }
  const date = inputTime;
  const y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let minute = date.getMinutes();
  minute = minute < 10 ? ('0' + minute) : minute;
  let second = date.getSeconds()
  second = second < 10 ? ('0' + second) : second;
  return  y + '-' + m + '-' + d + ' ' + h + ':' + minute;
}

export function deepClone(obj) {
  function getType(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1)
  }

  if (getType(obj) === 'Object') {
    const ret = {}
    for (const i in obj) {
      ret[i] = deepClone(obj[i])
    }
    return ret
  }
  if (getType(obj) === 'Array') {
    const ret = []
    obj.forEach(ele => {
      ret.push(deepClone(ele))
    })
    return ret
  }
  return obj
}

export function formatMoney(money){
  if(money === null || money === undefined){
    return ''
  }
  if(typeof money === 'number') {
    money =money.toString()
  }

  money = money.replace(/(\d)(?=(\d{3})+(\.|$))/g, '$1,');

  return money;
}

export function formatMoneyInt(money,info){
  if(money === null || money === undefined){
    return info?info:''
  }
  if(typeof money === 'number') {
    money =money.toString()
  }
  if( money.indexOf('￥') > -1) {
    money = money.replace('￥','');
    money = '￥' + parseFloat(money).toFixed(0);
  }else {
    money = parseFloat(money).toFixed(0);
  }

  money = money.replace(/(\d)(?=(\d{3})+(\.|$))/g, '$1,');

  return money;
}
